import { TextInput } from '@src/common/components/TextInput';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

export interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string;
}

export const InvoiceNumberFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <TextInput
      value={value}
      label={t('permitSearch.invoiceNumber')}
      onChange={(e) => {
        onFilterChange({ invoiceNumber: e.target.value as string });
      }}
    />
  );
};
